module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNGbc1a91d8959a97d00235aca19ebe4162.bc1a91d8.png";